import {
    SET_TOKEN,
    FAILED_GET_TOKEN,
    SET_USER,
    FAILED_GET_USER,
    FAILED_VERIFY_TOKEN,
    RESET_REDIRECT_STATE,
    SET_DME_CLIENTS,
    FAILED_GET_DME_CLIENTS,
    SET_CLIENT_PK,
    SUCCESS_RESET_PASSWORD,
    FAILED_RESET_PASSWORD,
    SUCCESS_RESET_PASSWORD_CONFIRM,
    FAILED_RESET_PASSWORD_CONFIRM,
    LOGOUT,
    RESET_ERROR_MESSAGE,
} from '../constants/authConstants';

const defaultState = {
    token: '',
    successMessage: null,
    errorMessage: null,
    username: '',
    useremail: '',
    clientname: '',
    clientId: null,
    isLoggedIn: false,
    redirect: false,
    dmeClients: [],
    clientPK: null,
    canZendeskWrite: false,
    // WHO THIS LOGIN IS, from /users/username/. 'dme' | 'client' | 'unlinked'.
    // null means "we have not been told", which is NOT the same as 'unlinked'
    // and must never be rendered as it: a screen that assumed null meant
    // unlinked would accuse every user of being unattached for the whole window
    // between page load and the identity call landing.
    accountType: null,
    // The server's own sentence for an unlinked login. Named `message` on the
    // wire and renamed here so it cannot be confused with errorMessage or
    // successMessage, both of which already live in this reducer.
    accountMessage: null,
};

export const AuthReducer = (state = defaultState, {
    type,
    token,
    successMessage,
    errorMessage,
    username,
    useremail,
    clientname,
    clientId,
    isLoggedIn,
    dmeClients,
    clientPK,
    canZendeskWrite,
    accountType,
    accountMessage
}) => {
    switch (type) {
        case LOGOUT:
            return {
                ...state,
                token: null,
                errorMessage: null,
                redirect: false,
                isLoggedIn: false,
                username: null,
                useremail: null,
                clientname: null,
                dmeClients: [],
                clientPK: null,
                canZendeskWrite: false,
                // CLEARED ON LOGOUT, and this is the one that would have hurt.
                // These screens run on shared warehouse workstations. Leaving
                // accountType behind would carry the previous person's identity
                // verdict into the next person's session, so the first thing a
                // freshly logged-in operator could see is "this login is not
                // linked to an account" about somebody else's login.
                accountType: null,
                accountMessage: null,
            };
        case SET_TOKEN:
            return {
                ...state,
                token: token,
                isLoggedIn: true,
                redirect : false,
            };
        case FAILED_GET_TOKEN:
        case FAILED_VERIFY_TOKEN:
            return {
                ...state,
                errorMessage: errorMessage,
                redirect : true,
            };
        case SUCCESS_RESET_PASSWORD:
        case SUCCESS_RESET_PASSWORD_CONFIRM:
            return {
                ...state,
                successMessage: successMessage,
                errorMessage: null
            };
        case FAILED_RESET_PASSWORD:
        case FAILED_RESET_PASSWORD_CONFIRM:
            return {
                ...state,
                errorMessage: errorMessage,
                successMessage: null
            };
        case SET_USER:
            return {
                ...state,
                username: username,
                clientname: clientname,
                useremail: useremail,
                clientId: clientId,
                clientPK: clientPK,
                // `=== undefined` and not `||`: 'unlinked' is a real answer and
                // so is null, but a response that predates these fields must
                // leave whatever we already knew alone rather than blanking it.
                // A plain `||` would also turn an empty-string message into
                // null, which is the same class of "falsy is not absent" bug
                // this file's clientId already carries elsewhere.
                accountType: accountType === undefined ? state.accountType : accountType,
                accountMessage: accountMessage === undefined
                    ? state.accountMessage : accountMessage,
                isLoggedIn: isLoggedIn,
                redirect : false,
                canZendeskWrite: canZendeskWrite,
            };
        // "We asked and could not find out" is not a verdict about the account,
        // so any previous answer is dropped rather than left standing. This is
        // the branch the unlinked logins themselves currently take: the identity
        // call 500s for them today (a pre-existing platform defect, not this
        // feature's), and a stale 'client' from an earlier session surviving
        // that failure would be the screen quietly asserting the wrong identity
        // at exactly the moment it knows least.
        case FAILED_GET_USER:
            return {
                ...state,
                errorMessage: errorMessage,
                isLoggedIn: isLoggedIn,
                accountType: null,
                accountMessage: null,
                redirect : true,
            };
        case RESET_REDIRECT_STATE:
            return {
                ...state,
                redirect: false,
            };
        case SET_DME_CLIENTS:
            return {
                ...state,
                dmeClients: dmeClients,
                redirect : false,
            };
        case FAILED_GET_DME_CLIENTS:
            return {
                ...state,
                errorMessage: errorMessage,
                redirect : false,
            };
        case SET_CLIENT_PK:
            return {
                ...state,
                clientPK: clientPK,
            };
        case RESET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: null,
            };
        default:
            return state;
        
    }
};



// WEBPACK FOOTER //
// src/state/reducers/authReducer.js